import { Activity } from "./activity";
import { BusinessCustomer } from "./customer";

export type ZeroDecimalCurrency = {
    currency: string;
    value: number;
    zeroDecimalCurrency: boolean;
}

export type Transaction = {
    id: string;
    merchantCode: string;
    orderReference: string;
    totalAmountCharged: ZeroDecimalCurrency;
    transactionDate: number;
    type: string;
    carbonOffsetQuantity: {
        unit: string;
        value: number;
    };
    emailAddress: string;
    ownershipType?: TransactionOwnershipType;
    programmeCode?: string;
    activity?: Activity;
    orderDescription?: string;
    description?: string;
}

export type TransactionsPage = {
    content: Transaction[],
    totalElements: number,
    totalPages: number
}

export type Price = {
    currency: string;
    symbol?: string;
    value: number;
    zeroDecimalCurrency?: boolean;
}

export type TransactionById = {
    id: string;
    netAmount: Price;
    paymentProviderFee: Price;
    serviceFee: Price;
    totalAmountCharged: Price;
    transactionDate: number;
    status: string;
    orderReference: string;
    type: string;
    ownershipType: TransactionOwnershipType;
    activity: Activity;
    merchantCode: string;
    emailAddress?: string;
    programmeCode?: string;
    orderDescription?: string;
    businessCustomer?: BusinessCustomer;
    customerFullName: string;
}

export type TransactionsSearchCriteria = {
    emailFilter?: string | undefined;
    programmeCode?: string | undefined;
    transactionOwnershipTypes: TransactionOwnershipType[];
    footprintTypeExclude?: string;
    withoutProgramme?: boolean;
}

export enum TransactionOwnershipType{
    MERCHANT = "MERCHANT",
    CUSTOMER = "CUSTOMER",
    PERSONAL = "PERSONAL"
}

export enum CustomerDataType {
    EMPLOYEE = "EMPLOYEE",
    CUSTOMER = "CUSTOMER"
}

export enum PurchaseType {
    FIXED_COST_SUBSCRIPTION = 'FIXED_COST_SUBSCRIPTION',
    CLIMATE_FRIENDLY_CART = 'CLIMATE_FRIENDLY_CART',
    FIXED_OFFSET = 'FIXED_OFFSET',
    AASF_REWARDS = 'AASF_REWARDS',
    GROUP_SUBSCRIPTION = 'GROUP_SUBSCRIPTION',
    JOURNEY = 'JOURNEY',
    FLIGHT = 'FLIGHT',
    BUSINESS_FOOTPRINT = 'BUSINESS_FOOTPRINT',
    EMISSION_RECORD = 'EMISSION_RECORD'
}